import {Slide} from "react-toastify";

const toastOptions = {
    position: 'top-center',
    autoClose: 4000,
    hideProgressBar: true,
    closeButton: false,
    newestOnTop: true,
    draggable: false,
    theme: "dark",
    transition: Slide,
    closeOnClick: true,
};

export default toastOptions;
